import React from 'react';
import Lists from '../components/Lists';

const List = ({
  user,
  userData,
  fetchBooks,
  fetchUserData,
  books,
  showNotification,
  updateCurrentlyReading,
}) => {
  return (
    <div className="container">
      {user && (
        <Lists
          user={user}
          userData={userData}
          fetchBooks={fetchBooks}
          fetchUserData={fetchUserData}
          books={books}
          showNotification={showNotification}
          updateCurrentlyReading={updateCurrentlyReading}
        />
      )}
    </div>
  );
};

export default List;
